import Label from '@/components/elements/Label/Label';

import DataGrid from '@/components/elements/lists/DataGrid';

import { getSelectedPaymentDetails } from '@/helpers/checkout';
import { _t } from '@/locale';
import { SelectedPaymentMethod as PaymentMethod } from '@/types/checkout';

type Props = {
  paymentMethod?: PaymentMethod;
  information?: string;
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
};

const PaymentDetailsMethod = ({ paymentMethod, information, baseTranslationKey }: Props) => {
  if (!paymentMethod && !information) {
    return null;
  }

  const { label } = paymentMethod ? getSelectedPaymentDetails(paymentMethod) : { label: '' };
  const paymentMethodLabel = label;

  const getPaymentMethod = () => {
    if (paymentMethod) {
      return (
        <DataGrid.Row>
          <DataGrid.Cell
            title={_t(`${baseTranslationKey}.ariaLabel.selectedPaymentMethod`)}
            type="description"
            ariaLabel={_t(`${baseTranslationKey}.ariaLabel.selectedPaymentMethod`)}
            truncate
          />
          <DataGrid.Cell
            title={
              <Label
                className="bg-bg_secondary text-fg_secondary whitespace-nowrap"
                label={paymentMethodLabel}
                size="lg"
              />
            }
            align="right"
            type="description"
            ariaLabel={_t(`${baseTranslationKey}.ariaLabel.selectedPaymentMethod`)}
          />
        </DataGrid.Row>
      );
    }
  };

  const getPaymentInformation = () => {
    if (!information) {
      return null;
    }
    return (
      <DataGrid.Row>
        <DataGrid.Cell
          title={_t(`${baseTranslationKey}.ariaLabel.freeCancelBefore`)}
          type="description"
          ariaLabel="can cancel before"
          truncate
        />
        <DataGrid.Cell
          title={
            <Label className="bg-bg_secondary text-fg_secondary whitespace-nowrap" label={information} size="lg" />
          }
          align="right"
          type="description"
          ariaLabel="information"
        />
      </DataGrid.Row>
    );
  };

  return (
    <div className="border-black-100 pt-sm border-t">
      {getPaymentMethod()}
      {getPaymentInformation()}
    </div>
  );
};

export default PaymentDetailsMethod;
